export default __webpack_public_path__ + "f40d31fae5780eeeca71a9be797e4be8.png";